export const ADD_DISCOUNT = 'ADD_DISCOUNT';
export const ADD_DISCOUNT_FULFILLED = 'ADD_DISCOUNT_FULFILLED';
export const ADD_DISCOUNT_REJECTED = 'ADD_DISCOUNT_REJECTED';

export const CLEAR_DISCOUNTS = 'CLEAR_DISCOUNTS';
export const CLEAR_DISCOUNTS_FULFILLED = 'CLEAR_DISCOUNTS_FULFILLED';
export const CLEAR_DISCOUNTS_REJECTED = 'CLEAR_DISCOUNTS_REJECTED';

export const FETCH_DISCOUNTS = 'FETCH_DISCOUNTS';
export const FETCH_DISCOUNTS_FULFILLED = 'FETCH_DISCOUNTS_FULFILLED';
export const FETCH_DISCOUNTS_REJECTED = 'FETCH_DISCOUNTS_REJECTED';

export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';
export const REMOVE_DISCOUNT_FULFILLED = 'REMOVE_DISCOUNT_FULFILLED';
export const REMOVE_DISCOUNT_REJECTED = 'REMOVE_DISCOUNT_REJECTED';

export const REMOVE_DISCOUNTS = 'REMOVE_DISCOUNTS';
export const REMOVE_DISCOUNTS_FULFILLED = 'REMOVE_DISCOUNTS_FULFILLED';
export const REMOVE_DISCOUNTS_REJECTED = 'REMOVE_DISCOUNTS_REJECTED';
export const RESET_REMOVE_DISCOUNTS = 'RESET_REMOVE_DISCOUNTS';

export const RESET_DISCOUNTS = 'RESET_DISCOUNTS';

export const SUBMIT_DISCOUNTS = 'SUBMIT_DISCOUNT';
export const SUBMIT_DISCOUNTS_FULFILLED = 'SUBMIT_DISCOUNT_FULFILLED';
export const SUBMIT_DISCOUNTS_REJECTED = 'SUBMIT_DISCOUNT_REJECTED';
